import { Injectable } from "@angular/core";

@Injectable()
export class CSSColorService {
  public getColor(color: string) {
    return getComputedStyle(document.body).getPropertyValue(color);
  }
}
